import { isTaskFormBased } from "@jugl-web/domain-resources/tasks/utils/isTaskFormBased";
import { PreviewTask } from "@jugl-web/rest-api/tasks";
import { FC } from "react";
import Highlighter from "react-highlight-words";
import { BaseListItem } from "../BaseListItem";
import { ReactComponent as OrderIcon } from "../../assets/order.svg";
import { ReactComponent as TaskIcon } from "../../assets/task.svg";

interface TaskListItemProps {
  task: PreviewTask;
  searchQuery: string;
  boardName: string;
  isSelected: boolean;
  onClick: () => void;
}

export const TaskListItem: FC<TaskListItemProps> = ({
  task,
  searchQuery,
  boardName,
  isSelected,
  onClick,
}) => (
  <BaseListItem
    startSlot={isTaskFormBased(task) ? <OrderIcon /> : <TaskIcon />}
    title={
      <Highlighter
        autoEscape
        highlightClassName="text-primary bg-transparent"
        searchWords={[searchQuery || ""]}
        textToHighlight={task.name}
      />
    }
    subtitle={boardName}
    endSlot={
      <span className="font-secondary shrink-0 text-sm leading-[21px] text-[#828282]">
        {task.order_id}
      </span>
    }
    isSelected={isSelected}
    onClick={onClick}
  />
);
